import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=5b60e88d&"
import script from "./copyright.vue?vue&type=script&lang=js&"
export * from "./copyright.vue?vue&type=script&lang=js&"
import style0 from "./copyright.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports